import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { faListAlt } from "@fortawesome/free-solid-svg-icons";
import { Bank } from "../../model/domain/Bank";
import { PagedList } from "../../model/domain/PagedList";
import { AuthService } from "../../services/auth.service";
import { DomainService } from "../../services/domain.service";

@Component({
  selector: "bank-list",
  templateUrl: "./bank-list.component.html",
  styleUrls: ["./bank-list.component.css"],
})
export class BankListComponent implements OnInit {
  faListAlt = faListAlt;

  displayedColumns = ["actions", "code", "shortName", "name"];

  code: string = null;
  name: string = null;
  banksList: Bank[] = null;
  currentPage: number = 1;
  totalPages: number = null;
  totalItems: number = null;
  listedPages: any[];
  firstItemOnPage: number;
  lastItemOnPage: number;

  constructor(
    private router: Router,
    private domainService: DomainService,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.getBanksList();
  }

  getBanksList(page: number = null, pageSize: number = null) {
    if (!page) {
      page = 1;
    }

    if (!pageSize) {
      pageSize = 10;
    }
    this.domainService
      .GetListBank(this.code, this.name, page, pageSize)
      .subscribe((q) => {
        this.banksList = q.results;
        this.renderPaginador(q, page);
      });
  }
  clearFilters() {
    this.domainService.GetListBank(null, null, 1, 10).subscribe((q) => {
      this.banksList = q.results;
      this.renderPaginador(q, 1);
    });

    this.name = null;
    this.code = null;
  }

  renderPaginador(result: PagedList<Bank>, page: number) {
    this.totalItems = result.rowCount;
    this.totalPages = result.pageCount;
    this.firstItemOnPage = result.firstRowOnPage;
    this.lastItemOnPage = result.lastRowOnPage;

    this.currentPage = page;

    this.listedPages = [];

    let startPage = this.currentPage - 2;

    if (startPage <= 0) {
      startPage = 1;
    }

    let maxPage = this.currentPage + 2;

    while (maxPage > this.totalPages) {
      maxPage--;
    }

    for (let i = startPage; i <= maxPage; i++) {
      this.listedPages.push(i);
    }

    if (!result.results.length) {
      this.totalPages = 1;
      this.currentPage = 1;
      this.firstItemOnPage = 0;

      this.listedPages = [];
      this.listedPages.push(1);
    }
  }

  openBank(id: number = null) {
    if (id === null) {
      this.router.navigate(["/bank-register"]);
    } else {
      this.router.navigate(["/bank-register", id]);
    }
  }
}
